import Vue from "vue"
import mountCancellationSurveyPage from "./mount"
import getLocale from "@/utils/locale"

const id = "vue-cancellation-survey"

export default () => {
  const el = document.querySelector(`#${id}`)
  if (!el) {
    return
  }

  const vm = mountCancellationSurveyPage(Vue, {
    locale: getLocale(),
    id: el.id
  })
  vm.$mount(el)
}
